import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';
import { cloneDeep } from 'lodash';
import classNames from 'classnames';
import ValidationErrorMessage from '@como/web-hub-components/src/ValidationErrorMessage/ValidationErrorMessage';


const InputWithErrors = (props) => {
  const { title, errorMessage, className } = props;
  const propsClone = cloneDeep(props);
  const clsName = classNames(className, { inputValueError: !!errorMessage });

  delete propsClone.errorMessage;

  return (
    <div className="input-wrapper">
      {title && <p className="action-label capitalize">{title}</p>}
      <Input
        {...propsClone}
        className={clsName}
      />
      {errorMessage && <ValidationErrorMessage
        dataAutomationId={'validation.error'}
        errorMessage={errorMessage}
      />}
    </div>
  );
};

InputWithErrors.propTypes = {
  title: PropTypes.string,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
};

export default InputWithErrors;
